module.exports = __webpack_public_path__ + "static/media/upcoming-stone.125d140c.svg";